import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "formControlId", "label", "error", "description"],
    _excluded2 = ["options", "onChange", "className", "title"],
    _excluded3 = ["options", "onChange", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useState } from 'react';
import classNames from 'classnames';
import { Dropdown, Form, Offcanvas, Typography } from '../';
import { Cross } from '../Icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var SelectInput = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _onClick = _ref.onClick,
      className = _ref.className,
      _ref$inputProps = _ref.inputProps,
      classNameInput = _ref$inputProps.className,
      formControlId = _ref$inputProps.formControlId,
      label = _ref$inputProps.label,
      error = _ref$inputProps.error,
      description = _ref$inputProps.description,
      inputProps = _objectWithoutProperties(_ref$inputProps, _excluded);

  return /*#__PURE__*/_jsxs(Form.Group, {
    className: "mb-3",
    controlId: formControlId,
    children: [label ? /*#__PURE__*/_jsx(Form.Label, {
      onClick: function onClick(e) {
        if (_onClick && !inputProps.disabled) {
          e.preventDefault();
          /* eslint-disable-next-line */
          // @ts-ignore: No way the get the type from bs

          _onClick(e);
        }
      },
      children: label
    }) : null, description ? /*#__PURE__*/_jsx(Form.Text, {
      className: "text-muted",
      children: description
    }) : null, /*#__PURE__*/_jsx(Form.Control, _objectSpread(_objectSpread({}, inputProps), {}, {
      className: classNames(className, classNameInput, 'form-control--select-like'),
      type: "text",
      onClick: function onClick(e) {
        if (_onClick) {
          e.preventDefault();

          _onClick(e);
        }
      },
      ref: ref,
      readOnly: true
    })), error ? /*#__PURE__*/_jsx(Form.Control.Feedback, {
      type: "invalid",
      children: error
    }) : null]
  });
});

var OffCanvasSelect = function OffCanvasSelect(_ref2) {
  var options = _ref2.options,
      onChange = _ref2.onChange,
      className = _ref2.className,
      title = _ref2.title,
      props = _objectWithoutProperties(_ref2, _excluded2);

  var _useState = useState(false),
      show = _useState[0],
      setShow = _useState[1];

  var _useState2 = useState(props['value']),
      value = _useState2[0],
      setValue = _useState2[1];

  var handleOnChange = function handleOnChange(value) {
    setValue(value);

    if (onChange) {
      onChange(value);
    }
  };

  var getName = function getName(id) {
    var _options$find;

    return ((_options$find = options.find(function (option) {
      return option.id === id;
    })) === null || _options$find === void 0 ? void 0 : _options$find.name) || '';
  };

  var handleClose = function handleClose() {
    return setShow(false);
  };

  var handleShow = function handleShow() {
    return setShow(true);
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SelectInput, {
      onClick: handleShow,
      inputProps: _objectSpread(_objectSpread({}, props), {}, {
        value: getName(value)
      })
    }), /*#__PURE__*/_jsxs(Offcanvas, {
      show: show,
      onHide: handleClose,
      placement: "bottom",
      children: [/*#__PURE__*/_jsx(Offcanvas.Header, {
        children: /*#__PURE__*/_jsxs(Offcanvas.Title, {
          className: "align-items-center d-flex justify-content-between w-100",
          children: [/*#__PURE__*/_jsx(Typography, {
            type: "sub-heading-1",
            children: title
          }), /*#__PURE__*/_jsx("button", {
            className: "btn",
            onClick: handleClose,
            children: /*#__PURE__*/_jsx(Cross, {})
          })]
        })
      }), /*#__PURE__*/_jsx(Offcanvas.Body, {
        children: /*#__PURE__*/_jsx(Dropdown.Menu, {
          className: "position-static shadow-none",
          show: true,
          children: options.filter(function (item) {
            return !item.hidden;
          }).map(function (item) {
            return /*#__PURE__*/_jsx(Dropdown.Item, {
              active: item.id === value,
              href: "#",
              onClick: function onClick(event) {
                return handleOnChange(item.id);
              },
              disabled: item === null || item === void 0 ? void 0 : item.disabled,
              children: item.name
            }, item.id);
          })
        })
      })]
    })]
  });
};

var Select = function Select(_ref3) {
  var options = _ref3.options,
      onChange = _ref3.onChange,
      className = _ref3.className,
      props = _objectWithoutProperties(_ref3, _excluded3);

  var _useState3 = useState(props['value']),
      value = _useState3[0],
      setValue = _useState3[1];

  var handleOnChange = function handleOnChange(value) {
    setValue(value);

    if (onChange) {
      onChange(value);
    }
  };

  var getName = function getName(id) {
    var _options$find2;

    return ((_options$find2 = options.find(function (option) {
      return option.id === id;
    })) === null || _options$find2 === void 0 ? void 0 : _options$find2.name) || '';
  };

  return /*#__PURE__*/_jsxs(Dropdown, {
    className: className,
    children: [/*#__PURE__*/_jsx(Dropdown.Toggle, {
      as: SelectInput,
      inputProps: _objectSpread(_objectSpread({}, props), {}, {
        value: getName(value)
      })
    }), /*#__PURE__*/_jsx(Dropdown.Menu, {
      align: "end",
      className: "dropdown-menu--fixed-height" // Hardcoded spacer-100 for now as it's not available in js
      ,
      popperConfig: {
        modifiers: [{
          name: 'offset',
          options: {
            offset: [0, 8]
          }
        }]
      },
      children: options.filter(function (item) {
        return !item.hidden;
      }).map(function (item) {
        return /*#__PURE__*/_jsx(Dropdown.Item, {
          active: item.id === value,
          href: "#",
          onClick: function onClick(event) {
            return handleOnChange(item.id);
          },
          disabled: item === null || item === void 0 ? void 0 : item.disabled,
          children: item.name
        }, item.id);
      })
    })]
  });
};

Select = /*#__PURE__*/React.memo(Select);
OffCanvasSelect = /*#__PURE__*/React.memo(OffCanvasSelect);
export default Select;
export { Select, OffCanvasSelect };